/* eslint-disable no-new  */
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import moment from 'moment'
import wysiwyg from 'vue-wysiwyg'
import 'vue-wysiwyg/dist/vueWysiwyg.css'
import StarRating from 'vue-star-rating'
import VueResource from 'vue-resource'
import VuePassword from 'vue-password'
import Simplert from 'vue2-simplert'
import VeeValidate from 'vee-validate'
import VueNumeric from 'vue-numeric'
import loading from 'vue-full-loading'
import autosize from 'autosize'
import VueButtonSpinner from 'vue-button-spinner'
// import { registerLicense } from '@syncfusion/ej2-base'
/* import fontawesome from '@fortawesome/fontawesome' */
import Dropdown from 'hsy-vue-dropdown'
import VueFormWizard from 'vue-form-wizard'
import VueClipboard from 'vue-clipboard2'
import vSelect from 'vue-select'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
// material-icons
import * as VueGoogleMaps from 'vue2-google-maps'
import VFacebookLogin, { vueFacebookLoginComponent } from 'vue-facebook-login-component'
// import * as Sentry from '@sentry/browser'
// import * as Integrations from '@sentry/integrations'
import VueToastr from '@deveodk/vue-toastr'
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css'
import 'vue-select/dist/vue-select.css'
import 'element-ui/lib/theme-chalk/index.css'

import ReadMore from 'vue-read-more'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import VueQuillEditor from 'vue-quill-editor'
import ApolloClient from 'apollo-boost'
import VueApollo from 'vue-apollo'
import datePicker from 'vue-bootstrap-datetimepicker'
import bFormSlider from 'vue-bootstrap-slider'
import { Datetime } from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'
import 'nestable2/jquery.nestable.scss'
import 'bootstrap-slider/dist/css/bootstrap-slider.css'
import ToggleButton from 'vue-js-toggle-button'
import VuejsDialog from 'vuejs-dialog'
import 'vuejs-dialog/dist/vuejs-dialog.min.css'
Vue.use(VuejsDialog)
Vue.use(datePicker)
Vue.use(bFormSlider)
Vue.use(Datetime)
Vue.use(ToggleButton)
// jQuery
global.jQuery = require('jquery')
require('nestable2')
var $ = global.jQuery
window.$ = $
/* Sentry.init({
  dsn: 'https://85a47881d2594262a9ebe93b2f2c5412@sentry.io/1540632',
  integrations: [new Integrations.Vue({Vue, attachProps: true})]
})
*/
// Vue.use(ComponentName)
Vue.use(BootstrapVue)

Vue.use(VueResource)
Vue.use(autosize)
Vue.use(VFacebookLogin, vueFacebookLoginComponent)
Vue.use(loading)
Vue.use(Simplert)
Vue.use(VueNumeric)
Vue.component(VuePassword)
Vue.use(VueButtonSpinner)
/* Vue.use(fontawesome) */
Vue.component('star-rating', StarRating)
Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker)
Vue.use(Dropdown)
Vue.use(VueFormWizard)
VueClipboard.config.autoSetContainer = true // add this line
Vue.use(VueClipboard)
Vue.use(vSelect)
Vue.use(ReadMore)
Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 2000
})
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDbABuU2mTBWi4mUR7q3FDdt6zl4xVnf_w',
    libraries: 'places'
  }
})
Vue.use(wysiwyg, {
  hideModules: {
    'justifyRight': true,
    'justifyCenter': true,
    'code': true,
    'table': true,
    'italic': true,
    'removeFormat': true
  },
  'forcePlainTextOnPaste': true
})
Vue.use(VueQuillEditor)
// Vue.component('b-card-group', bCardGroup)
moment.locale('da')
const config = {
  errorBagName: 'validationerrors', // change if property conflicts
  fieldsBagName: 'fields',
  delay: 0,
  locale: 'en',
  dictionary: null,
  strict: true,
  classes: false,
  classNames: {
    touched: 'touched', // the control has been blurred
    untouched: 'untouched', // the control hasn't been blurred
    valid: 'valid', // model is valid
    invalid: 'invalid', // model is invalid
    pristine: 'pristine', // control has not been interacted with
    dirty: 'dirty' // control has been interacted with
  },
  events: 'input|blur',
  inject: true,
  validity: false,
  aria: true
}
Vue.use(ElementUI)
Vue.use(VeeValidate, config)
Vue.prototype.moment = moment
const apolloClient = new ApolloClient({
  uri: 'https://graphql.ordrestyring.dk/graphiql'
})

Vue.use(VueApollo)
const apolloProvider = new VueApollo({
  defaultClient: apolloClient
})
// http
Vue.prototype.$bitrixapi = process.env.BITRIXAPI
Vue.http.options.root = 'https://www.kundematch.dk/partnerService.php'
Vue.http.headers.common['X-Requested-With'] = 'XMLHttpRequest'
new Vue({
  el: '#app',
  router,
  apolloProvider,
  template: '<App/>',
  components: {
    App
  }
})

var filter = function (text, length, clamp) {
  clamp = clamp || '...'
  var node = document.createElement('div')
  node.innerHTML = text
  var content = node.textContent
  return content.length > length ? content.slice(0, length) + clamp : content
}

Vue.filter('truncate', filter)
document.querySelectorAll('.grid-list').forEach(button => button.addEventListener('click', toggle))
function toggle () {
  let btn = this
  btn.classList.add('animation')
  btn.classList.toggle('active')
  let newElem = btn.cloneNode(true)
  btn.parentNode.replaceChild(newElem, btn)
  newElem.addEventListener('click', toggle)
}

Vue.prototype.$maskibanNumber = (value) => {
  // remove all special chars empty
  // var val = str.replace(/[^a-zA-Z0-9 ]/g, '')
  // remove all non numeric chars
  var val = value.replace(/\D/g, '')
  var stringValue = ''
  var formattedValue = ''
  var firstTexts = 'DK'
  var space = ' '
  stringValue = firstTexts + val.toString()
  var valueCharData = Array.from(stringValue)
  valueCharData.forEach((prop, index) => {
    if (index === 3 || index === 7 || index === 11 || index === 15) {
      formattedValue += prop + space
    } else {
      formattedValue += prop
    }
  })
  return formattedValue
}

// finansieringCalc
// function formatCurrency (total) {
//   var neg = false
//   if (total < 0) {
//     neg = true
//     total = Math.abs(total)
//   }
//   return (neg ? '' : '') + parseFloat(total, 10).toFixed(0).replace('.', ',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.').toString()
// }
// function calculateInput () {
//   $('#loanWarning1').hide()
//   $('.loanInfo').show()
//   var loanAmount = parseInt($('#loanAmount').val())
//   if (loanAmount < 5000 || loanAmount > 350000) {
//     $('#loanWarning1').slideDown()
//     $('.loanInfo').slideUp()
//     return
//   }
//   $('.calc-result').addClass('loadingimentor')
//   objname = 'dynamObject'
//   // constants
//   var loantypeid = $('#typeid').val()
//   var chainId = 'DAN'
//   $('#loanAmountHidden').val(loanAmount)
//   // inputs
//   // var loanAmount = $('#loanAmount').val();
//   var terms = $('#terms').val()
//   var repayment = $('#repayment').val()
//   var url = 'https://www.kundematch.dk/bank/bank.php'
//   url += '?loanTypeId=' + loantypeid
//   url += '&terms=' + terms
//   url += '&repayment=' + repayment
//   url += '&loanAmount=' + loanAmount
//   url += '&chainId=' + chainId
//   $.ajax({
//     url: url + '&idtime=' + new Date().getTime(),
//     type: 'POST',
//     cache: false,
//     success: function (data, textStatus, jqXHR) {
//       dataLoan = data
//       $('#AdministrationFee').html(formatCurrency(data['AdministrationFee']))
//       $('#InterestRate').html(data['InterestRate'])
//       $('#Repayment').html(data['Repayment'])
//       $('#RegistrationFee').html(formatCurrency(data['RegistrationFee']))
//       $('#CreditCosts').html(data['CreditCosts'])
//       $('#CostsPercent').html(data['CostsPercent'])
//       $('#TotalAmountToBeRepayed').html(formatCurrency(data['TotalAmountToBeRepayed']))
//       $('#Pbs').html(data['Pbs'])
//       $('#NominalInterestPercent').html(data['NominalInterestPercent'])
//       $('.calc-result').removeClass('loadingimentor')
//     },
//     error: function (jqXHR, textStatus, errorThrown) {
//       alert(textStatus)
//     }
//   })
// }
// calculateInput()

// Redirect to webshop categories when clicked
if (document.querySelector('#dropWebshop') !== null) {
  setTimeout(() => {
    var webshopMenu = document.querySelector('#dropWebshop')
    webshopMenu.addEventListener('click', function () {
      window.location.replace('#/webshop/overview')
    })
  }, 500)
}
// Hide Customer project, Messages, Mine kunder test if not test users
if (process.env.BITRIXAPI !== 'https://bitrixapidev.haandvaerker.dk/v1/') {
  setTimeout(() => {
    if (document.querySelector('ul.nav-dropdown-items li#customer-projects\\/project-dashboard') !== null) {
      document.querySelector('ul.nav-dropdown-items li#customer-projects\\/project-dashboard').classList.add('hide')
    }
    // if (document.querySelector('ul.nav-dropdown-items li#customer-projects\\/approved-projects') !== null) {
    //   document.querySelector('ul.nav-dropdown-items li#customer-projects\\/approved-projects').classList.add('hide')
    // }
    // if (document.getElementById('dropBeskeder') !== null) {
    //   document.getElementById('dropBeskeder').classList.add('hide')
    // }
    // if (document.getElementById('dropMine kunder Test') !== null) {
    //   document.getElementById('dropMine kunder Test').classList.add('hide')
    // }
  }, 300)
}
// Redirect to marketplace when clicked
if (document.querySelector('#dropMarkedsplads') !== null) {
  setTimeout(() => {
    var maketplace = document.querySelector('#dropMarkedsplads')
    maketplace.addEventListener('click', function () {
      window.location.replace('#/markedsplads')
    })
  }, 500)
}
// Hide webshop if not isshop
if (localStorage.getItem('isshop') === 'false') {
  if (document.getElementById('dropWebshop') !== null) {
    setTimeout(() => {
      document.getElementById('dropWebshop').classList.add('hide')
    }, 500)
  }
}
var anbefalingerSammendrag = document.getElementById('anbefalinger-sammendrag')
if (anbefalingerSammendrag) {
  if (Vue.prototype.$bitrixapi !== 'https://bitrixapidev.haandvaerker.dk/v1/') {
    setTimeout(() => {
      anbefalingerSammendrag.classList.add('hide')
    }, 300)
  }
}
// Hide opgaveinvitationer
var opgaveInvitationer = document.getElementById('opgaveinvitationer')
if (opgaveInvitationer) {
  if (localStorage.getItem('isjobInvited') === 'false' || localStorage.getItem('showAddendum') !== 'true') {
    setTimeout(() => {
      opgaveInvitationer.classList.add('hide')
    }, 500)
  }
}

// Hide udbud if not in bitrixpackage
var offentligeUdbud = document.getElementById('offentlige-udbud')
if (offentligeUdbud) {
  if (localStorage.getItem('PartnerLoginUdbudJobs') === 'false') {
    setTimeout(() => {
      document.getElementById('offentlige-udbud').classList.add('hide')
    }, 500)
    // setTimeout(() => {
    //   document.getElementById('privat-udbud').classList.add('hide')
    // }, 500)
  }
}
// Registering Syncfusion license key
// registerLicense(process.env.VUE_APP_PDF_LICENSE)

if (typeof document.getElementById('js-licensing') !== 'undefined' && document.getElementById('js-licensing') !== null) {
  setInterval(function () {
    var x = document.getElementById('js-licensing')
    x.style.display = 'none'
    console.log(x.style.display)
  }, 500)
}
//  Digital package
var badgeNavItem = document.querySelector('a[href="#/badges"]')
if (badgeNavItem) {
  if (localStorage.getItem('showbadgewebshop') === 'yes') {
    badgeNavItem.classList.remove('hide')
  } else {
    badgeNavItem.classList.add('hide')
  }
}
//  Addendum
var Addendum = document.querySelector('#dropArbejdsseddel')
if (Addendum) {
  if (localStorage.getItem('showAddendum') === 'true') {
    Addendum.classList.remove('hide')
  } else {
    Addendum.classList.add('hide')
  }
}



// WEBPACK FOOTER //
// ./src/main.js